import { http } from "@/http/http.js";
export default {
  queryProjectList (params) {
    return http.post("/web/project/queryList", params);
  },
  //暂存-提交项目
  saveProject (params) {
    return http.post("/web/project/save", params);
  },
  //查询项目详情
  queryProjectDetail (params) {
    return http.post("/web/project/queryDetail", params);
  },
  //审批项目
  auditProject (params) {
    return http.post("/web/project/audit", params);
  },
  //作废项目
  cancelProject (params) {
    return http.post("/web/project/cancel", params);
  },
  //查询合同信息
  queryContractInfo (params) {
    return http.post("/web/contractManage/queryContractInfo", params);
  },
  //查询所有工作项
  queryAllWorkItem (params) {
    return http.post("/web/workitem/queryAllWorkItem", params);
  },
  queryAllWorkItemByProjectId (params) {
    return http.post("/web/workitem/queryAllWorkItemByProjectId", params);
  },
  //查询所有工作项
  getDictList (params) {
    return http.post("/common/getDictList", params);
  },
  //查询区县街道列表
  getStreetList (params) {
    return http.post("/web/jd/list", params);
  },
  //更新项目清单
  updateProjectItemList (params) {
    return http.post("/web/project/updateProjectItemList", params);
  },
};
